module.exports = __webpack_public_path__ + "img/beforeandafter2.e2d14efe.png";